import {
  FETCH_AUDITTRACEDETAILS_SUCCESS_ACTION

} from "./action";

const initialState = {
  processing: false,
  error: false
};


export default function(state: any = initialState, action: Function) {
  switch (action.type) {

    case FETCH_AUDITTRACEDETAILS_SUCCESS_ACTION:

      return {
        ...state,
        auditTraceDtlsList: action.payload.rows,
        auditTraceDtlsCount: action.payload.count
      };
    default:
      return {
        ...state
      };
  }
}
